import React from 'react';
import { Form, Input, Button,Spin,Select,Switch,Divider, message } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;

const { Option } = Select;

class TriggerForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    workflow_type:'',
    active:false,
    description:'',
    abbreviation:'',

    actions:[],
    action:'',

    staff_roles:[],
    responsible_roles:[],

    outcome:'Positive',
    condition:'',
    is_auto_prompt:false,

    application_formfields:[],
    auto_prompted_fields:[],

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/actionworkflowmappings/?workflow=${this.props.mapping_obj.workflow}`)
    .then(res => {
        this.setState({
          actions:res.data
        })
      })


    axios.get(serverconfig.backendserverurl+`/api/staff_roles/`)
    .then(res => {
        this.setState({
          staff_roles:res.data
        })
       // this.setState({datarequested:false})
    })



    axios.get(serverconfig.backendserverurl+`/api/application_formfields/?workflow=${this.props.mapping_obj.workflow}`)
    .then(res => {
        this.setState({
            application_formfields:res.data
        })
        this.setState({datarequested:false})
  
    })




  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    if (this.state.is_auto_prompt===true && this.state.auto_prompted_fields.length<=0){
      message.error("Please select atleast one prompt field for applicant")
    }else{

      this.setState({datarequested:true})
      let form_data = new FormData();
      form_data.append('action', this.state.action);
      form_data.append('outcome', this.state.outcome);
      form_data.append('trigger_action', this.props.mapping_obj.action);
      form_data.append('condition', this.state.condition);
      form_data.append('action_workflow_mapping', this.props.mapping_obj.id);
      form_data.append('is_auto_prompt', this.state.is_auto_prompt);
      form_data.append('auto_prompted_fields',JSON.stringify(this.state.auto_prompted_fields));
  
      axios.post(serverconfig.backendserverurl+'/api/action_triggers/', form_data, {
        headers: {
          'content-type': 'multipart/form-data'
        }
      })
    .then(res => {
      this.setState({responsible_roles:[]})
      this.setState({action:''})
  
      this.setState({datarequested:false})
      this.component_reloaded()
  
      ///refesrh
      this.props.onRefresh()
  
    }    
  
    )
    .catch(error => console.log(error))


    }




  }

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
     <div>
    <Form onFinish={(event) => this.handleFormSubmit(event)}>


    <FormItem label="OutCome">
          <Select 
          placeholder="Action" 
          style={{  }} 
          value={this.state.outcome}
          onChange={(val)=>{
            this.setState({outcome:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
                <Option value={'Positive'}>{'Positive'}</Option>
                <Option value={'Negative'}>{'Negative'}</Option>

          </Select>
      </FormItem>


    <FormItem label="Action"
        name="action"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Action" 
          style={{  }} 
          value={this.state.action}
          onChange={(val)=>{
            this.setState({action:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
            {this.state.actions.map(
              (type)=>(
                <Option value={type.action}>{type.action_name} {' <> '} {type.order} </Option>
              ))}
          </Select>
      </FormItem>

      <FormItem label="Condition">
        <TextArea
          placeholder="Condition"
          autoSize={{ minRows: 2, maxRows: 6 }}
          value={this.state.condition}
          onChange={(val)=>{this.setState({condition:val.target.value})}}
        />
        
      </FormItem>


      <Form.Item label="Auto Prompt Applicant" >
          <Switch
              checked={this.state.is_auto_prompt}
              onChange={val=>{this.setState({is_auto_prompt:val})}}
              checkedChildren="Yes"
              unCheckedChildren="No"
              />
       </Form.Item>


       {
        this.state.is_auto_prompt===true?
        <div>
            {
                this.state.application_formfields.length>0?
                <div style={{display:'flex',flexDirection:'column'}}>
                <h6>Select Auto prompt fields .</h6>

                {this.state.application_formfields.map((item) => (
                  <p style={{display:'flex',flexDirection:'row'}}>
                  <Switch
                    onChange={(val) => {
                      if (val === true) {
                        var obj={
                          'id':item.id,
                          'label':item.label
                        }
                      
                        var new_array = [
                          ...this.state.auto_prompted_fields,
                          obj,
                        ];
                        this.setState({ auto_prompted_fields: new_array });

                      } else {
                        this.setState({
                          auto_prompted_fields: [
                            ...this.state.auto_prompted_fields.filter(
                              (todo) => todo.id!== item.id
                            ),
                          ],
                        });
                      }
                      
                    }}
                    style={{marginRight:2}} 

                  ></Switch>{" "}
                  {item.label} 
                </p>

                ))}

                <Divider></Divider>
                </div>

                :
                null
              }


        </div>
        :
        null
       }



      <FormItem>
        <Button  type="primary" htmlType="submit">Add Trigger</Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default TriggerForm;



